import { PathlossCatalogResponse } from '../types/systems';
import { makeSafeRequest } from './makeSafeRequest';

export const unavailablePathlossCatalog = (
	reason = 'Pathloss catalog request failed'
): PathlossCatalogResponse => ({
	available: false,
	profiles: [],
	reason,
});

export const downloadPathlossCatalog = async (): Promise<PathlossCatalogResponse> => {
	return (
		(await makeSafeRequest<PathlossCatalogResponse>('pathloss-profiles/', 'GET')) ||
		unavailablePathlossCatalog()
	);
};
